import React from 'react';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const ConfirmReservation = lazyLoad(
  () => import('./page'),
  module => module.ConfirmReservationPage,
  { fallback: <LoadingContainer loading /> },
);
